import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { UserContext, UserNameContext } from '../../contexts/user.context';
import SignIn from '../../components/signin/signin.component';
import { 
	MyWebAccessContainer
 } from "./my-web-access.styles";

const MyWebAccess = () => {
    const { currentUser } = useContext(UserContext);
    const { userName } = useContext(UserNameContext);

    if(currentUser !== null) {
        return <Navigate to={
            `../profile/${userName}`
        } replace />;
    }

	return(
		<MyWebAccessContainer>
            <h1>Ahh You fou'nd me 😢 - Now lets ths be our lil tle secret🤫🤐</h1>
            <SignIn />
		</MyWebAccessContainer>
	);
}

export default MyWebAccess;